import { render, staticRenderFns } from "./QontakCustomerCare.vue?vue&type=template&id=0b3f8854&scoped=true&"
import script from "./QontakCustomerCare.vue?vue&type=script&lang=js&"
export * from "./QontakCustomerCare.vue?vue&type=script&lang=js&"
import style0 from "./QontakCustomerCare.vue?vue&type=style&index=0&id=0b3f8854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f8854",
  null
  
)

export default component.exports